import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { IInterval } from '@/types/common/IInterval';
import { Box, Card, CardBody, Fade, Grid, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Temporal } from 'temporal-polyfill';

interface IProps {
	event: ICalendarEvent;
}

export default function EventSummary(props: IProps) {
	return (
		<Fade in={true}>
			<Card cursor="pointer" borderRadius="md">
				<CardBody display="grid" gridTemplateColumns="1fr">
					<Grid gridTemplateColumns="1fr auto" alignItems="center" mb={1}>
						<Grid gridTemplateColumns="auto 1fr" alignItems="center" gap={2}>
							<Box h={2} w={2} backgroundColor="primary.500" borderRadius="full" />
							<Text fontSize="small" fontWeight={500} color="gray.500">
								{getDateString(props.event.interval)}
							</Text>
						</Grid>
					</Grid>

					<Text fontWeight={700}>{props.event.summary}</Text>
					<Text fontSize="small" color="gray.600">
						{props.event.description}
					</Text>
				</CardBody>
			</Card>
		</Fade>
	);
}

function getDateString(interval: IInterval | null): string {
	if (!interval) {
		return t('PENDING');
	}

	const start = Temporal.ZonedDateTime.from(`${interval.inclusiveStart.dateTime}[${interval.inclusiveStart.timeZone}]`);
	const end = Temporal.ZonedDateTime.from(`${interval.exclusiveEnd.dateTime}[${interval.exclusiveEnd.timeZone}]`);

	return `
	${start.hour.toString().padStart(2, '0')}:${start.minute.toString().padStart(2, '0')} - ${end.hour
		.toString()
		.padStart(2, '0')}:${end.minute.toString().padStart(2, '0')}`;
}
